import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title } from "utils";

import { Header } from "components";

import source from "assets/images/PowerBi/Source.jpg";
import autreWeb from "assets/images/PowerBi/AutreWeb.png";
import popup from "assets/images/PowerBi/popup.png";
import okay from "assets/images/PowerBi/OK.jpg";
import connecter from "assets/images/PowerBi/Connecter.jpg";

//Page pour les intructions power bi
class PowerBiPage extends Component {
  render() {
    const bread = [{ text: "Instructions Power BI" }];

    return (
      <Fragment>
        <Helmet>{title("Instructions Power BI")}</Helmet>

        <div className="PowerBi--container main-content">
          <Header title="Instructions Power BI" bread={bread} />

          <h3>Les utilisateurs mac ne peuvent pas avoir accès à Power BI Desktop</h3>
          <div className="PowerBi--cards">
            <div className="PowerBi--instructions">
              <h2>
                1. Ouvrez Power BI Desktop, puis sélectionnez « Obtenir des données d'une autre
                source ».
              </h2>
              <h2>2. Sélectionnez « Autre », puis « Web ».</h2>
            </div>
            <div className="PowerBi--instructionsImg">
              <img src={source} alt="" />
              <img src={autreWeb} alt="" />
            </div>
          </div>
          <div className="PowerBi--cards">
            <div className="PowerBi--instructions">
              <h2>3. Sur CLB, copiez le lien du champ « Lien pour les données ».</h2>
              <h2>
                4. Dans Power BI, sélectionnez « Avancé » et collez le lien dans le champ « Parties
                d'URL ».
              </h2>
              <h2>5. Sur CLB, copiez le lien du champ « Authorization ».</h2>
              <h2>
                6. Dans Power BI, écrivez « Authorization » dans le champ « Paramètres de l'en-tête
                de la requête ». Ensuite, collez ce que vous avez copié dans le deuxième champ à
                droite, puis appuyez sur « OK »
              </h2>
            </div>
            <div className="PowerBi--instructionsImg">
              <img src={popup} alt="" />
              <img src={okay} alt="" />
            </div>
          </div>
          <div className="PowerBi--cards">
            <div className="PowerBi--instructions">
              <h2>7. Appuyez sur « Se connecter ». Vous avez maintenant accès aux données.</h2>
            </div>
            <div className="PowerBi--instructionsImg">
              <img src={connecter} alt="" />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PowerBiPage;
